<!-- begin:: Aside -->
<template>
  <!-- <button class="kt-aside-close" id="kt_aside_close_btn">
    <i class="fal fa-times"></i>
  </button> -->
  <div
    class="kt-aside kt-aside--fixed kt-grid__item kt-grid kt-grid--desktop kt-grid--hor-desktop"
    id="kt_aside"
    v-bind:style="$getContainerOption('sidebar_bg_color')"
  >
    <aside-brand />
    <div :style="backgroundColor">
      <vue-perfect-scrollbar :settings="settings" v-once>
        <aside-menu />
      </vue-perfect-scrollbar>
    </div>
  </div>
</template>
<!-- end:: Aside -->
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { findIndex as _findIndex } from 'lodash-es';
import AsideBrand from './AsideBrand.vue';
import AsideMenu from './AsideMenu.vue';

export default {
  name: 'AsideBase',
  components: {
    AsideBrand,
    AsideMenu,
    VuePerfectScrollbar,
  },
  data: () => ({
    settings: {
      maxScrollbarLength: 60,
    },
  }),
  computed: {
    backgroundColor() {
      return `background-color: ${this.$getSetting(
        'sidebar_bg_color'
      )}!important`;
    },
  },
};
</script>
